import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import './About/About.css';
import bgImage from './About/Background.png';
import DetectIcon from './About/Detect.png';
import StructureIcon from './About/Structure.png';
import SendIcon from './About/send.png';

export default function Info() {
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target;
          if (entry.isIntersecting) {
            target.classList.add('visible');
          } else {
            target.classList.remove('visible');
          }
        });
      },
      { threshold: 0.3 }
    );

    const sections = document.querySelectorAll('.info-section');
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className="info-page" style={{ backgroundImage: `url(${bgImage})` }}>
      {/* WHY 섹션 */}
      <section className="info-section why">
        <h1>{t('about.why.title')}</h1>
        <p>
          <Trans i18nKey="about.why.desc" />
        </p>
      </section>

      {/* HOW 섹션 */}
      <section className="info-section how">
        <h1>{t('about.how.title')}</h1>
        <p className="how-lead-text">
          <Trans i18nKey="about.how.lead" components={{ strong: <strong /> }} />
        </p>

        <div className="how-steps">
          <div className="how-card">
            <img className="how-icon" src={DetectIcon} alt={t('about.how.steps.detect.title')} />
            <h2>{t('about.how.steps.detect.title')}</h2>
            <p>{t('about.how.steps.detect.desc')}</p>
          </div>
          <div className="how-card">
            <img className="how-icon" src={StructureIcon} alt={t('about.how.steps.structure.title')} />
            <h2>{t('about.how.steps.structure.title')}</h2>
            <p>{t('about.how.steps.structure.desc')}</p>
          </div>
          <div className="how-card">
            <img className="how-icon" src={SendIcon} alt={t('about.how.steps.send.title')} />
            <h2>{t('about.how.steps.send.title')}</h2>
            <p>{t('about.how.steps.send.desc')}</p>
          </div>
        </div>

        <p className="how-footer-text">
          <Trans i18nKey="about.how.footer" components={{ strong: <strong /> }} />
        </p>
      </section>

      {/* WHAT 섹션 */}
      <section className="info-section what">
        <h1>{t('about.what.title')}</h1>
        <div className="what-columns">
          <div className="what-card">
            <h2>{t('about.what.cards.appearance.title')}</h2>
            <p>{t('about.what.cards.appearance.desc')}</p>
          </div>
          <div className="what-card">
            <h2>{t('about.what.cards.mind.title')}</h2>
            <p>{t('about.what.cards.mind.desc')}</p>
          </div>
          <div className="what-card">
            <h2>{t('about.what.cards.health.title')}</h2>
            <p>{t('about.what.cards.health.desc')}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
